import {createElement, Component, PropTypes} from 'rlink-react';
import {FormattedMessage} from 'react-intl';
import {Picture} from 'rlink-repos/content-components';
import navActions from 'rlink-router/actions';
import {FacebookShare, TwitterShare} from 'rlink-social-share/component';

export class FeaturedStories extends Component {
  render () {
    let articles = [];
    let coverIndex = this.props.articleData.size - 1;
    let index = coverIndex;
    while (articles.length < this.props.maxArticles) {
      if (index >= 0) {
        let article = this.props.articleData.get(index);
        articles.push(<ArticleCard
          key={index}
          coverStory={(index === coverIndex)}
          {... this.props}
          {... article.toJS()} />);

        index--;
      } else {
        articles.push(<div />);
      }
    }

    let coverStory = articles[0];
    articles.shift();

    return (<div>{coverStory}<div className={this.props.css['featured-articles']}>{articles}</div></div>);
  }
}



FeaturedStories.propTypes = {
  maxArticles: PropTypes.number,
};

FeaturedStories.defaultProps = {
  maxArticles: 3
}

export class LatestStories extends Component {
  constructor (props) {
    super(props);
    this.state = {
      maxArticles: props.maxArticles
    };

  }

  render () {
    let articles = [];
    let index = (this.props.articleData.size) - 1 - this.props.offset;
    while (articles.length < this.state.maxArticles) {
      if (index >= 0) {
        let article = this.props.articleData.get(index);
        articles.push(<ArticleSummary
          {... this.props}
          {... article.toJS()} />);

        index--;
      } else {
        break;
      }
    }

    return (<div className={this.props.css["latest-news-articles"]}>
      {articles}
      {(this.state.maxArticles < this.props.articleData.size - this.props.offset)
        ? <a className={this.props.css.ShowMore} onClick={() => this.setState({maxArticles: this.state.maxArticles + this.props.showMoreAmount})}>Show More</a>
        : ''}
    </div>);
  }

}

LatestStories.propTypes = {
  offset: PropTypes.number,
  maxArticles: PropTypes.number,
  showMoreAmount: PropTypes.number,
}

LatestStories.defaultProps = {
  maxArticles: 5,
  offset: 3,
  showMoreAmount: 5
}

export class ArticleComponent extends Component {
  redirectToContent (ev, view = 'article') {
    if (ev.button === 1) {
      return;
    }
    if (!ev.target.classList.contains('social-share-button')) {
      ev.preventDefault();
      if (this.props.isExternal) {
        navActions.ExternalNavTo({
          url: this.props.externalUrl,
        });
      } else {
        navActions.NavTo({
          view,
          transition: 'fade',
          returnTransition: 'fade',
          params: {slug: this.props.slug},
        });
      }
    } else {
      return false;
    }
  }

  href () {
    return (this.props.isExternal) ? this.props.externalUrl : `/article/${this.props.slug}`;
  }

  formatDate (dateRaw) {
    let date = new Date(dateRaw);

    return `${this.props.monthNames[date.getMonth()]} ${(date.getDate() < 10) ? `0${date.getDate()}` : date.getDate()} ${date.getFullYear()}`;
  }

}

ArticleComponent.propTypes = {
  monthNames: PropTypes.array,
};

ArticleComponent.defaultProps = {
  monthNames: [
    'Jan', 'Feb', 'Mar',
    'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep',
    'Oct', 'Nov', 'Dec',
  ],
};


class ArticleCard extends ArticleComponent {
  render () {
    let shareUrl = `${(typeof window.location !== 'undefined') ? window.location.origin : ''}/article/${this.props.slug}`;
    let readMoreText = 'Read More';
    if (this.props.isExternal) {
      shareUrl = this.props.externalUrl;
      if (this.props.externalUrl.match(/^(http[s]:\/\/www.youtube.com|http[s]:\/\/www.twitch.tv)/)) {
        readMoreText = 'Watch Now';
      }
    }

    return (
      <article className={`${this.props.css['article-card']} ${(this.props.coverStory) ? this.props.css['cover-story'] : ''}`}>
        <Picture
          className={this.props.css['story-image']}
          src={this.props.bannerImageFormats.src}
          widths={this.props.bannerImageFormats.widths}
          heights={this.props.bannerImageFormats.heights}
          formats={this.props.bannerImageFormats.formats} />
        <a href={this.href()} onClick={ev => this.redirectToContent(ev)}>
          <div className={this.props.css['social-links']}>
            <ul>
              <li>
                <FormattedMessage
                  id="ui.label.button.SHARE_ARTICLE"
                  defaultMessage="share"
                  description="Button that shows up on the article card." />
              </li>
              <FacebookShare fontAwesome={this.props.fontAwesome} css={this.props.css} shareUrl={shareUrl} shareText={this.props.title} />
              <TwitterShare fontAwesome={this.props.fontAwesome} css={this.props.css} shareUrl={shareUrl} shareText={this.props.title} />
            </ul>
          </div>
          <div className={this.props.css['cover-story-content']}>
            <h4>{this.formatDate(this.props.publishedOn)}</h4>
            <h3>{this.props.title}</h3>

            <p>
              {this.props.introduction}
              <span style={{visibility: 'collapse'}}>
                <FormattedMessage
                  id="ui.label.button.ARTICLE_CARD_READ_ARTICLE"
                  defaultMessage="read more"
                  description="Button that shows up on the article card." />
              </span>
            </p>
            <span className={this.props.css['read-more']}>{readMoreText} {(this.props.isExternal) ? <i className={`${this.props.fontAwesome.fa} ${this.props.fontAwesome['fa-external-link']} ${this.props.fontAwesome['fa-lg']}`} /> : []}</span>
          </div>
        </a>
      </article>
    );
  }
}

class ArticleSummary extends ArticleComponent {
  render () {
    return (
      <article className={`${this.props.css['article-summary']}`}>
        <a href={this.href()} onClick={ev => this.redirectToContent(ev)}
          className={`${this.props.css['article-img']}`}>
          <Picture
            className={this.props.css['story-image']}
            src={this.props.bannerImageFormats.src}
            widths={this.props.bannerImageFormats.widths}
            heights={this.props.bannerImageFormats.heights}
            formats={this.props.bannerImageFormats.formats} />
        </a>
        <div className={this.props.css['article-text']}>
          <h4>{this.formatDate(this.props.publishedOn)}</h4>
          <h3><a href={this.href()} onClick={ev => this.redirectToContent(ev)}>{this.props.title}</a></h3>

          <p>
            {this.props.introduction}
          </p>
          <a href={this.href()} onClick={ev => this.redirectToContent(ev)}>
            <span className={this.props.css['read-more']}>
              <FormattedMessage
                id="ui.label.link.ARTICLE_SUMMARY_READ_ARTICLE"
                defaultMessage="read more"
                description="Button that shows up on the article summary." />
              {this.props.isExternal ? <i className={`${this.props.fontAwesome.fa} ${this.props.fontAwesome['fa-external-link']} ${this.props.fontAwesome['fa-lg']}`} /> : []}
            </span>

          </a>
        </div>
      </article>
    );
  }

}



// WEBPACK FOOTER //
// ./lib/rlink-blog/component.jsx